"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pkceChallengeFromVerifier = exports.base64encode = exports.sha256 = exports.generateRandomString = exports.parseQuery = exports.navigate = exports.currentUri = void 0;
var currentUri = function () {
    var _a = window.location, origin = _a.origin, pathname = _a.pathname;
    return "" + origin + pathname;
};
exports.currentUri = currentUri;
var navigate = function (uri, replace) {
    if (replace) {
        return window.history.replaceState(null, '', uri);
    }
    window.location.replace(uri);
};
exports.navigate = navigate;
var parseQuery = function () {
    var query = new URLSearchParams(window.location.search);
    var authCode = query.get('code');
    var authState = query.get('state');
    return {
        authCode: authCode,
        authState: authState,
    };
};
exports.parseQuery = parseQuery;
// PKCE HELPER FUNCTIONS
// Generate a secure random string using the browser crypto functions
var generateRandomString = function (crypto) {
    var array = new Uint32Array(28);
    crypto.getRandomValues(array);
    return Array.from(array, function (dec) { return ("0" + dec.toString(16)).substr(-2); }).join('');
};
exports.generateRandomString = generateRandomString;
// Calculate the SHA256 hash of the input text.
// Returns a promise that resolves to an ArrayBuffer
var sha256 = function (crypto, plain) { return __awaiter(void 0, void 0, void 0, function () {
    var encoder, data;
    return __generator(this, function (_a) {
        encoder = new TextEncoder();
        data = encoder.encode(plain);
        return [2 /*return*/, crypto.subtle.digest('SHA-256', data)];
    });
}); };
exports.sha256 = sha256;
// Base64-urlencodes the input string
var base64encode = function (buff) {
    // Convert the ArrayBuffer to string using Uint8 array to convert to what btoa accepts.
    // btoa accepts chars only within ascii 0-255 and base64 encodes them.
    var str = '';
    var arr = new Uint8Array(buff);
    arr.forEach(function (byte) {
        str += String.fromCharCode(byte);
    });
    return btoa(str);
};
exports.base64encode = base64encode;
// Return the base64-urlencoded sha256 hash for the PKCE challenge
var pkceChallengeFromVerifier = function (crypto, v) { return __awaiter(void 0, void 0, void 0, function () {
    var hash;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, exports.sha256(crypto, v)];
            case 1:
                hash = _a.sent();
                return [2 /*return*/, exports.base64encode(hash)];
        }
    });
}); };
exports.pkceChallengeFromVerifier = pkceChallengeFromVerifier;
